import React, { useState } from 'react';
import CardForm from '../../../../../Utils/Cards/CardForm';
import { reduxForm } from 'redux-form';
import FincancialCashDetailTable from './FinancialFlowTable';
import InvestmentsFlow from './InvestmentsFlow';
import OperatingFlowTable from './OperatingFlowTable';
import ResumeFlow from './ResumeFlow';
import LoadMask from 'Utils/LoadMask/LoadMask';
import './CashFlow.css';

let CashFlowForm = props => {
    const { handleSubmit, editar, item, eliminar, data, changeCurrency } = props;
    
    // Estado para manejar la moneda
    const [currency, setCurrency] = useState(props.currency || 'USD');

    if (!data || !data.year_list) {
        return (
            <LoadMask blur>
            </LoadMask>
        );
    }

    const handleCurrencyChange = (event) => {
        const newCurrency = event.target.value;
        setCurrency(newCurrency);
        if (changeCurrency) {
            changeCurrency(newCurrency, item);
        }
    };


    return (
        <form onSubmit={handleSubmit}>
            <div className='col-sm-12 p-0'>
                <CardForm
                    icon="Side_activos/Admin.svg"
                    titulo="PROYECCIONES DE FLUJO DE CAJA"
                    subtitulo="RESUMEN"
                    subtituloForm={editar ? "VISUALIZACIÓN" : "NUEVO"}
                    col="12"
                    noShadow
                >
                    <div className="mb-3 d-flex align-items-center">
                        <label htmlFor="currency-selector" style={{ marginRight: '10px', marginBottom: '0' }}>Expresado en:</label>
                        <select 
                            id="currency-selector" 
                            className="form-control custom-select" 
                            style={{ width: '180px', border: 'none', outline: 'none', boxShadow: 'none' }} 
                            value={currency} 
                            onChange={handleCurrencyChange}
                        >
                            <option value="USD">Dólar US$</option>
                            <option value="GTQ">Quetzales (GTQ)</option>
                        </select>
                    </div>

                    <ResumeFlow 
                        {...props} 
                        dollar_exchange={item} 
                        eliminar={eliminar} 
                        year_list={data.year_list}
                        currency={currency}
                    />
                    <OperatingFlowTable 
                        {...props} 
                        dollar_exchange={item} 
                        eliminar={eliminar} 
                        year_list={data.year_list}
                        currency={currency}
                    />
                    <InvestmentsFlow 
                        {...props} 
                        dollar_exchange={item}
                        data={{ ...data, year_list: data.year_list }}
                        currency={currency}
                    />
                    <br />
                    <FincancialCashDetailTable 
                        {...props} 
                        dollar_exchange={item} 
                        eliminar={eliminar} 
                        year_list={data.year_list}
                        currency={currency}
                    />
                </CardForm>
            </div>
        </form>
    );
};

CashFlowForm = reduxForm({
    form: 'CashFlowForm',
})(CashFlowForm);

export default CashFlowForm;
